/*
Copyright 2022 by Herbert Potechius,
Ernst-Abbe-Hochschule Jena - University of Applied Sciences - Department of Electrical Engineering and Information
Technology - Immersive Media and AR/VR Research Group.
All rights reserved.
This file is released under the "MIT License Agreement".
Please see the LICENSE file that should have been included as part of this package.
*/

import React from 'react';
import './Card.scss';
import Images from 'constants/Images';
import Texts from 'constants/Texts';
import SystemConfiguration from "settings/SystemConfiguration"
import Mesh from "rendering/Mesh"
import $ from "jquery"


class Card extends React.Component {
    constructor(props) {
      super(props);
      this.state = {render: true};
    }

    handleClick(text) {
        console.log("Click")
        $("#rightpanel_header").html(text).css("color", "black")

        // SystemConfiguration.mesh_out = <MeshObj file_name="data/meshes/ArtecRay/ArtecRay"></MeshObj>
        var f_name = "data/meshes/" + text + "/" + text + "_reflectance"
        console.log(f_name)
        SystemConfiguration.mesh_out = <Mesh file_name={f_name}></Mesh>
        SystemConfiguration.zip_file = window.location.href + "/data/meshes/" + text + "/" + text + ".zip"
        SystemConfiguration.mesh_name = text
        SystemConfiguration.mtl_file = window.location.href + "/data/meshes/" + text + "/" + text + ".mtl"

        // set the information in the infobox
        var infobox = document.getElementById("rightpanel_infobox")
        //var selected_item = SystemConfiguration.mesh_data.find(element => element["name"] == text)
        //console.log(SystemConfiguration.mesh_data)

        // get object json
        var xmlhttp = new XMLHttpRequest();

        // NOTE: Local variable
        // var url = "EvaVisualiser/data/meshes/" + text + "/" + text + ".json";
        // NOTE: Remote variable
        // var url = "data/meshes/" + text + "/" + text + ".json";

        var url = process.env.PUBLIC_URL + "/data/meshes/" + text + "/" + text + ".json";



        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                var myArr = JSON.parse(xmlhttp.responseText);
                var selected_item = myArr[0]
                infobox.innerHTML = 
                                    "<span style='color:black; font-weight:bold; line-height: 2.5em'>" + "Name" + "</span>" + "</br>" 
                                    + selected_item["name"] + "</br>" 
                                    + "<span style='color:black; font-weight:bold; line-height: 2.5em'>" + "Filename" + "</span>" + "</br>" 
                                    + selected_item["filename"] + "</br>" 
                                    + "<span style='color:black; font-weight:bold; line-height: 2.5em'>" + "Type" + "</span>" + "</br>" 
                                    + selected_item["type"] + "</br>" 
                                    + "<span style='color:black; font-weight:bold; line-height: 2.5em'>" + "Mesh" + "</span>" + "</br>" 
                                    + "Vertices: " + selected_item["mesh"]["vertices"] + "</br>" 
                                    + "Faces: " + selected_item["mesh"]["faces"] + "</br>" 
                                    + "<span style='color:black; font-weight:bold; line-height: 2.5em'>" + "Captured" + "</span>" + "</br>" 
                                    + selected_item["captured"] + "</br>" 
                                    + "<span style='color:black; font-weight:bold; line-height: 2.5em'>" + "License" + "</span>" + "</br>" 
                                    + selected_item["license"] + "</br>" 
                                    + "<span style='color:black; font-weight:bold; line-height: 2.5em'>" + "Author" + "</span>" + "</br>" 
                                    + selected_item["author"] + "</br>" 
                                    + "<span style='color:black; font-weight:bold; line-height: 2.5em'>" + "URL" + "</span>" + "</br>" 
                                    + "<a href='"+selected_item["url"]+"'>"+selected_item["url"]+"</a>" + "</br>"
            }
        }.bind(this)
        xmlhttp.open("GET", url, true);
        xmlhttp.send();


        // check mesh availability (sm, l, m, h, pc)
        // var xhr2 = new XMLHttpRequest();
        // var filen = process.env.PUBLIC_URL + "/data/meshes/" + text + "/" + text + "_low.obj";
        // xhr2.onreadystatechange = function() {
        //   console.log(xhr2.readyState)
        //   console.log(xhr2.status)
        //   // if (xhr2.readyState == 4 && xhr2.status == 200) {
        //   //   var myArr = xhr2.responseText;
        //   //   console.log(myArr)
        //   //   console.log("jjjj")
        //   // }
        // }.bind(this)
        // xhr2.open("HEAD", filen, true);
        // xhr2.send();



        var xhr2 = new XMLHttpRequest();
        var filen = process.env.PUBLIC_URL + "/data/meshes/" + text + "/" + text + "s_lows.obj";
        xhr2.open('HEAD', filen);

        xhr2.onreadystatechange = function() {
          console.log(this.DONE)
          if (this.readyState === 4) {
            if (this.status === 200) {
              console.log('Resource exists');
            } else if (xhr2.status === 404) {
              console.log('Resource does not exist');
            }
          }
        };
        xhr2.send();
        
    }


    render() {
        return (
            <div id="card_main" onClick={() => this.handleClick(this.props.filename)}>
              <img id="card_body" src={process.env.PUBLIC_URL + "/data/meshes/" + this.props.filename + "/preview_" + this.props.filename +".png"}/>
              <div id="card_footer">
                  {this.props.filename}
                  <br/>
                  <div id="card_description">{this.props.description}</div>
              </div>
              <div id="card_description_hider"></div>
            </div>
        );
    }
  }

export default Card;